<template>
  <a-social-sharing
    hashtags="finance_magnates,fm"
    twitter-user="finance_magnates"
    network="linkedin"
    :url="sharingUrl"
    :title="title"
    :description="description"
    :quote="title"
    :open-in-iframe="openInIframe"
  >
    <a-icon
      v-bind="$attrs"
      is-button
      tabindex="-1"
      :icon="$attrs.icon || ICON.SOCIAL_SQUARE_LINKEDIN"
    />
  </a-social-sharing>
</template>

<script>
import socialSharing from '../socialSharing'

export default {
  name: 'LinkedIn',
  mixins: [socialSharing]
}
</script>
